import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'business',
    name: 'business',
    component: () => import('@/layout/routerView.vue'),
    redirect: '/business/activity',
    meta: { title: '营销管理', icon: 'svg:menu-marketing', order: 70 },
    children: [
      { path: 'activity', name: 'business_activity', component: () => import('./Activity/index.vue'), meta: { title: '营销活动管理' } },
      { path: 'statistics', name: 'business_statistics', component: () => import('./Statistics/index.vue'), meta: { title: '营销统计' } }
    ]
  }
]

export default routes
